module.exports = __webpack_public_path__ + "img/tiktok.a642c170.svg";